import { RootState } from '@reducers/index';
import { ChallengeScoreSummary } from 'src/types/shared/Challenge';
import { ChallengeCalendarAdminOption } from 'src/types/shared/User';

export const getChallengesForGroupID = (state: RootState, id: number) =>
    Object.values(state.challengesReducer.challenges).filter(
        ({ challengeGroupID }) => challengeGroupID === id,
    );

export const getChallenges = (state: RootState) => state.challengesReducer.challenges;
export const getChallenge = (state: RootState, id: number) =>
    state.challengesReducer.challenges[id] ?? {};
export const getChallengeAssessors = (state: RootState) => state.challengesReducer.assessors;
export const getChallengeLeads = (state: RootState) => state.challengesReducer.leads;
export const getChallengesIsFetching = (state: RootState): boolean =>
    state.challengesReducer.isFetching;
export const getChallengesFetchError = (state: RootState): string | null =>
    state.challengesReducer.fetchError;
export const getChallengesIsPosting = (state: RootState): boolean =>
    state.challengesReducer.isPosting;
export const getChallengesPostSuccess = (state: RootState): boolean =>
    state.challengesReducer.postSuccess;
export const getChallengesPostError = (state: RootState): string | null =>
    state.challengesReducer.postError;
export const getChallengesIsDeleting = (state: RootState): boolean =>
    state.challengesReducer.isDeleting;
export const getChallengesDeleteSuccess = (state: RootState): boolean =>
    state.challengesReducer.deleteSuccess;
export const getChallengesDeleteError = (state: RootState): string | null =>
    state.challengesReducer.deleteError;
export const getChallengesIsPatching = (state: RootState): boolean =>
    state.challengesReducer.isPatching;
export const getChallengesPatchSuccess = (state: RootState): boolean =>
    state.challengesReducer.patchSuccess;
export const getChallengesPatchError = (state: RootState): string | null =>
    state.challengesReducer.patchError;
export const getChallengeScoreSummary = (state: RootState, id: number): ChallengeScoreSummary =>
    state.challengesReducer.challengeScoreSummaries[id];
export const getCalendarWorkshopAdmins = (
    state: RootState,
): Record<number, ChallengeCalendarAdminOption> => state.challengesReducer.calendarWorkshopAdmins;
export const getCalendarAssessors = (
    state: RootState,
): Record<number, ChallengeCalendarAdminOption> => state.challengesReducer.calendarAssessors;
export const getCalendarPitchPresentationAdmins = (
    state: RootState,
): Record<number, ChallengeCalendarAdminOption> =>
    state.challengesReducer.calendarPitchPresentationAdmins;
